// extracted by mini-css-extract-plugin
export default {"cabecalho":"Header_cabecalho__X2+VO","cabecalho__container":"Header_cabecalho__container__jYowm","cabecalho__input":"Header_cabecalho__input__NJF-s"};